import { ReactNode } from "react";

import Skeleton from "../Skeleton";
import { cn } from "@/libs/cn";

interface TotalizersCardSkeletonParams {
  hasTitle?: boolean;
  hasValue?: boolean;
  hasSubValue?: boolean;
}

interface TotalizersCardParams {
  cardClassName?: string;
  titleClassName?: string;
  valueClassName?: string;
  dateClassName?: string;
  title: string;
  value: string | ReactNode;
  subValue: string | ReactNode;
  icon: React.ReactNode;
}

export const TotalizersCardSkeleton = ({ hasTitle = true, hasValue = true, hasSubValue = true }: TotalizersCardSkeletonParams) => (
  <div className="flex w-full justify-between bg-white rounded-lg shadow gap-2 p-4 items-start h-full">
    <div className="flex flex-col flex-1 gap-1 justify-between h-full">
      {hasTitle && <Skeleton className="h-5.25 w-3/4" />}
      {hasValue && <Skeleton className="h-8 w-1/2 my-1" />}
      {hasSubValue && <Skeleton className="h-5 w-1/4" />}
    </div>

    <Skeleton className="size-8 rounded-lg shrink-0" />
  </div>
);

export const TotalizersCard = ({
  cardClassName,
  titleClassName,
  valueClassName,
  dateClassName,
  title,
  value,
  subValue,
  icon,
}: TotalizersCardParams) => (
  <div className={cn("flex w-full justify-between bg-white rounded-lg shadow gap-1 p-4 items-start h-full", cardClassName)}>
    <div className="flex flex-col flex-1 justify-between gap-1 h-full">
      <span className={cn("text-[12px] text-ui-text/60 font-semibold leading-tight", titleClassName)}>{title}</span>

      <div className="my-1">
        <span className={cn("text-[22px] text-ui-text-dark font-semibold", valueClassName)}>{value}</span>
      </div>

      <span className={cn("text-xs text-ui-text/40", dateClassName)}>{subValue}</span>
    </div>

    <div className="shrink-0">{icon}</div>
  </div>
);
